import React, { Component } from "react";
import Img from "react-image";
import moment from "moment";
import { connect } from "react-redux";
import _ from "lodash";
import Classnames from "classnames";
import {
  deltaTime,
  SVGIcon,
  convTime,
  getStatusToString,
  getObjetSanteToString,
  enfantStatuSwitch,
  iconEVENTSwitch,
  getEtatSanteToString,
  textEVENTSwitch,
  iconSanteSwitch,
  iconRepaSwitch,
  getRepasToString,
  RepaSwitch,
} from "../../../../../ReactConst2";
import { getArriveEvent } from "../../modals/modal-enfant/les-tabs-ducks/Arrive.ducks";
import { getSanteEvent } from "../../modals/modal-enfant/les-tabs-ducks/Sante.ducks";
import { getPetitCoinEvent } from "../../modals/modal-enfant/les-tabs-ducks/Petitcoin.ducks";
import { getRepasEvent } from "../../modals/modal-enfant/les-tabs-ducks/Repas.ducks";
import { getSiesteEvent } from "../../modals/modal-enfant/les-tabs-ducks/Sieste.ducks";
import { getActiviteEvent } from "../../modals/modal-enfant/les-tabs-ducks/Activite.ducks";
import { getDepartEvent } from "../../modals/modal-enfant/les-tabs-ducks/Depart.ducks";
import { startUpdateEvents } from "../../modals/Modals.ducks";
import {
  getJournee,
  NotificationsDelete,
} from "../les-tabs-ducks/Journee.ducks";
import { css } from "@emotion/core";
import srcIconSieste from "../../../../../styles/img/icon-sieste.svg";
import srcIconHistoriqueMedical from "../../../../../styles/img/icon-historique-medical.svg";
import srcIconTransmission from "../../../../../styles/img/icon-transmission.svg";
import srcIconRepas from "../../../../../styles/img/icon-repas.svg";
import srcIconBiberon from "../../../../../styles/img/icon-biberon.svg";
import srcIconSante from "../../../../../styles/img/icon-sante.svg";
import DotLoader from "react-spinners/DotLoader";
import { Redirect } from "react-router-dom";
import ModalNotifications from "../les-tabs/ModalNotifications";
import ModalTransmission from "./ModalTransmission";
import { Service } from "../../../../service/service";
import { API } from "../../../../../const";

function getEventAPI(event) {
  let typeEvent = event.typeEvent;
  switch (typeEvent) {
    case "ARRIVEE":
      return `${API}api/enfant/creche/arrivees/${event.idEvent}`;
    case "ACTIVITE":
    case "PATE_A_MODELER":
    case "PEINTURE":
    case "PEINTURE":
    case "DANSE":
    case "PEINTURE":
    case "SORTIE":
    case "PISCINE":
    case "LECTURE":
    case "ACTIVITE_MANUELLE":
    case "AUTRE":
      return `${API}api/enfant/creche/activites/${event.idEvent}`;
    case "DEPART":
      return `${API}api/enfant/creche/departs/${event.idEvent}`;
    case "ABSENCE":
      return `${API}api/enfant/creche/agendas/timeline/${event.idEvent}`;
    case "INCIDENT":
    case "FIEVRE":
    case "VOMI":
    case "TOUX":
    case "BLESSURE":
    case "BOUTONS":
    case "AUTRE":
      return `${API}api/enfant/creche/incidents/${event.idEvent}`;
    case "SIESTE":
      return `${API}api/enfant/creche/siestes/${event.idEvent}`;
    case "REPAS":
    case "BIBERON":
    case "REPAS_PEU":
    case "REPAS_CORRECTEMENT":
    case "REPAS_BEAUCOUP":
      return `${API}api/enfant/creche/repas/${event.idEvent}`;
    case "PETITCOIN":
    case "PETITE_COMMISSION":
    case "GROSSE_COMMISSION":
      return `${API}api/enfant/creche/petits-coins/${event.idEvent}`;
    default:
  }
}

const IconRepas = () => (
  <object
    data={srcIconRepas}
    type="image/svg+xml"
    className="img-fluid"
    style={{ width: "40px", cursor: "pointer" }}
  />
);
const IconSieste = () => (
  <object
    data={srcIconSieste}
    type="image/svg+xml"
    className="img-fluid"
    style={{ width: "40px", cursor: "pointer" }}
  />
);
const IconHistoriqueMedical = () => (
  <object
    data={srcIconHistoriqueMedical}
    type="image/svg+xml"
    className="img-fluid"
    style={{ width: "40px", cursor: "pointer" }}
  />
);
const EnfantBiberon = () => (
  <object
    data={srcIconBiberon}
    type="image/svg+xml"
    className="img-fluid"
    style={{ width: "40px", cursor: "pointer" }}
  />
);
const IconSante = () => (
  <object
    data={srcIconSante}
    type="image/svg+xml"
    className="img-fluid"
    style={{ width: "40px", cursor: "pointer" }}
  />
);
const IconTransmission = () => (
  <object
    data={srcIconTransmission}
    type="image/svg+xml"
    className="img-fluid"
    style={{ width: "40px", cursor: "pointer" }}
  />
);
const IconTransmission2 = () => (
  <Img src={srcIconTransmission} className="img-fluid" alt="iconPhoto" />
);

const override = css`
  display: block;
  margin: 0 auto;
  border-color: red;
`;

class Journee extends Component {
  constructor(props) {
    super(props);
    this.state = {
      kidItem: {},
      tabToUpdate: "",
      redirect: false,
      modalTransmission: false,
      transmissionLoading: false,
      eventsDetails: [],
      modalNotifications: false,
      NotificationList: [],
    };
    this.handleClickUpdateEvent = this.handleClickUpdateEvent.bind(this);
    this.handleDeleteNotifications = this.handleDeleteNotifications.bind(this);
    this.onCloseModaleTransmission = this.onCloseModaleTransmission.bind(this);
    this.onOpenModaleNotifications = this.onOpenModaleNotifications.bind(this);
    this.onCloseModaleNotifications = this.onCloseModaleNotifications.bind(
      this
    );
  }

  onOpenModaleNotifications() {
    this.setState({ modalNotifications: true });
  }
  onCloseModaleNotifications() {
    this.setState({ modalNotifications: false, NotificationList: [] });
  }

  componentDidMount() {
    if (!_.isEmpty(this.props.kidItem)) {
      const response = Service.get(
        `${API}api/enfant/creche/enfants/${this.props.kidItem.id}/agendas/timeline`,
        {
          headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
        }
      );
      response
        .then((res) => {
          if (res.data.notifications != undefined) {
            this.setState({
              NotificationList: res.data.notifications,
              modalNotifications: true,
            });
          }
        })
        .catch((err) => {});
      this.props.getJournee(this.props.kidItem.id);
    }
  }
  componentDidUpdate(prevProps) {
    if (
      !_.isEmpty(this.props.kidItem) &&
      prevProps.kidItem !== this.props.kidItem
    ) {
      if (this.props.kidItem.nbNotifications > 0) {
        this.props.onOpenModaleNotifications();
      }
      this.props.getJournee(this.props.kidItem.id);
    }
  }
  handleDeleteNotifications = (listNotifications) => {
    let ids = [];
    ids = !_.isEmpty(listNotifications)
      ? listNotifications.map((element) => element.id)
      : [];
    this.props.NotificationsDelete(localStorage.getItem("token"), ids);
    this.props.onCloseModaleNotifications();
  };
  onCloseModaleTransmission() {
    this.setState({ modalTransmission: false, transmissionLoading: false });
  }
  handleModeTransmission(orderList) {
    let cleanList = [];
    const someFunction = () => {
      cleanList = orderList
        .reverse()
        .filter((elmnt) => elmnt.typeEvent !== "NEXT_BIBERON");
      const promises = cleanList.map(async (myValue) => {
        let urlAPI = getEventAPI(myValue);
        return await Service.get(urlAPI, {
          headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
        });
      });
      return Promise.all(promises);
    };
    this.setState({ modalTransmission: true, transmissionLoading: true });
    someFunction().then((data) => {
      let eventsDetails = data.map((event, index) => {
        return { typeEvent: cleanList[index]["typeEvent"], event: event.data };
      });
      this.setState({
        eventsDetails: eventsDetails,
        transmissionLoading: false,
      });
    });
  }

  handleClickUpdateEvent(event) {
    let typeEvent = event.typeEvent;
    let tabToUpdate;
    switch (typeEvent) {
      case "ARRIVEE":
        {
          tabToUpdate = "arrivee-tab";
          this.props.getArriveEvent(
            localStorage.getItem("token"),
            event.idEvent
          );
        }
        break;
      case "ACTIVITE":
      case "PATE_A_MODELER":
      case "PEINTURE":
      case "PEINTURE":
      case "DANSE":
      case "PEINTURE":
      case "SORTIE":
      case "PISCINE":
      case "LECTURE":
      case "ACTIVITE_MANUELLE":
      case "AUTRE":
        {
          tabToUpdate = "activite-tab";
          this.props.getActiviteEvent(
            localStorage.getItem("token"),
            event.idEvent
          );
        }
        break;
      case "DEPART":
        {
          tabToUpdate = "depart-tab";
          this.props.getDepartEvent(
            localStorage.getItem("token"),
            event.idEvent
          );
        }
        break;
      case "ABSENCE":
        {
          tabToUpdate = "absence-tab";
          this.props.getArriveEvent(
            localStorage.getItem("token"),
            event.idEvent
          );
        }
        break;
      case "INCIDENT":
      case "FIEVRE":
      case "VOMI":
      case "TOUX":
      case "BLESSURE":
      case "BOUTONS":
      case "AUTRE":
        {
          tabToUpdate = "sante-tab";
          this.props.getSanteEvent(
            localStorage.getItem("token"),
            event.idEvent
          );
        }
        break;
      case "SIESTE":
        {
          tabToUpdate = "sieste-tab";
          this.props.getSiesteEvent(
            localStorage.getItem("token"),
            event.idEvent
          );
        }
        break;
      case "REPAS":
      case "BIBERON":
      case "REPAS_PEU":
      case "REPAS_CORRECTEMENT":
      case "REPAS_BEAUCOUP":
        {
          tabToUpdate = "repas-tab";
          this.props.getRepasEvent(
            localStorage.getItem("token"),
            event.idEvent
          );
        }
        break;
      case "PETITCOIN":
      case "PETITE_COMMISSION":
      case "GROSSE_COMMISSION":
        {
          tabToUpdate = "petitcoin-tab";
          this.props.getPetitCoinEvent(
            localStorage.getItem("token"),
            event.idEvent
          );
        }
        break;
      default:
        break;
    }
    if (typeEvent !== "NEXT_BIBERON")
      this.props.toUpdateEvent(tabToUpdate, event.idEvent);
  }
  render() {
    let { dataJournee, kidItem } = this.props;
    let { redirect } = this.state;
    let orderList =
      !_.isEmpty(this.props.dataJournee) &&
      !_.isEmpty(this.props.dataJournee.eventsEnfant)
        ? dataJournee.eventsEnfant.sort((a, b) =>
            moment(b.timeDebutEvent).diff(a.timeDebutEvent)
          )
        : [];
    return (
      <div
        className="tab-pane  show active"
        id="journee-pane"
        role="tabpanel"
        aria-labelledby="journee-tab"
      >
        {this.props.loadingJournee ? (
          <div className="content p-0">
            <DotLoader
              size={100}
              color={"#ff7d26"}
              css={override}
              loading={this.props.loadingJournee}
            />
          </div>
        ) : (
          <div className="content p-0">
            {redirect && (
              <Redirect
                push
                to={{
                  pathname: "/",
                  search: `?tab=${this.state.tabToUpdate}`,
                  state: { referrer: "/enfant" },
                }}
              />
            )}
            <div className="row">
              <div className="col-md-4">
                <div className="bloc-recap blue">
                  <div className="title">Actuellement</div>
                  {!_.isEmpty(kidItem) &&
                  !_.isEmpty(kidItem.agenda) &&
                  !_.isEmpty(kidItem.agenda.statutDetails.statut) ? (
                    <div className="d-flex align-items-center justify-content-center content-recap">
                      <SVGIcon
                        name={
                          !_.isEmpty(kidItem) &&
                          !_.isEmpty(kidItem.agenda) &&
                          kidItem.agenda.statutDetails.statut
                        }
                        size="40px"
                      />
                      <span className="libelle">
                        {getStatusToString(
                          kidItem.agenda.statutDetails.statut,
                          kidItem.agenda.statutDetails.dateTime
                        )}
                      </span>
                    </div>
                  ) : (
                    ""
                  )}
                </div>
                <div
                  className={Classnames(
                    "bloc-recap",
                    {
                      red:
                        !_.isEmpty(dataJournee) &&
                        !_.isEmpty(dataJournee.etatSante) &&
                        !_.isEmpty(dataJournee.etatSante.etatSante) &&
                        (dataJournee.etatSante.etatSante === "INQUIETANT" ||
                          dataJournee.etatSante.etatSante === "A_SURVEILLER"),
                    },
                    {
                      blue:
                        (!_.isEmpty(dataJournee) &&
                          !_.isEmpty(dataJournee.etatSante) &&
                          !_.isEmpty(dataJournee.etatSante.etatSante) &&
                          dataJournee.etatSante.etatSante !== "INQUIETANT" &&
                          dataJournee.etatSante.etatSante !== "A_SURVEILLER") ||
                        _.isEmpty(dataJournee),
                    }
                  )}
                >
                  <div className="title">État de santé</div>
                  {!_.isEmpty(dataJournee) &&
                  !_.isEmpty(dataJournee.etatSante) &&
                  !_.isEmpty(dataJournee.etatSante.etatSante) &&
                  dataJournee.etatSante.etatSante ? (
                    <div className="d-flex align-items-center justify-content-center content-recap">
                      <IconSante />
                      <span className="libelle">
                        <strong>
                          {getObjetSanteToString(
                            dataJournee.etatSante.etatSante
                          )}
                        </strong>
                      </span>
                    </div>
                  ) : (
                    <div className="d-flex align-items-center justify-content-center content-recap">
                      <IconHistoriqueMedical />
                      <span className="libelle">Rien à signaler </span>
                    </div>
                  )}
                </div>
                <div className="bloc-recap blue">
                  <div className="title">Dernier repas</div>
                  {!_.isEmpty(dataJournee) &&
                  !_.isEmpty(dataJournee.dernierRepas) ? (
                    <div className="d-flex align-items-center justify-content-center content-recap">
                      {dataJournee.dernierRepas.biberon &&
                      dataJournee.dernierRepas.quantite > 0 ? (
                        <div className="d-flex align-items-center justify-content-center content-recap">
                          <EnfantBiberon />
                          <span className="libelle">
                            {getRepasToString(dataJournee.dernierRepas.type, dataJournee.dernierRepas.dateTime)}
                            <strong>
                              {dataJournee.dernierRepas.quantite + " " + "ml"}
                            </strong>
                            <strong>
                              {RepaSwitch(dataJournee.dernierRepas.etatRepas)}
                            </strong>
                          </span>
                        </div>
                      ) : (
                        <div className="d-flex align-items-center justify-content-center content-recap">
                          <IconRepas />
                          <span className="libelle">
                            {getRepasToString(dataJournee.dernierRepas.type, dataJournee.dernierRepas.dateTime)}
                            <strong>
                              {RepaSwitch(dataJournee.dernierRepas.etatRepas)}
                            </strong>
                          </span>
                        </div>
                      )}
                    </div>
                  ) : (
                    <div className="d-flex align-items-center justify-content-center content-recap">
                      <IconRepas />
                      <span className="libelle">Aucun </span>
                    </div>
                  )}
                </div>
                <div className="bloc-recap blue">
                  <div className="title">Dernière sieste</div>
                  {!_.isEmpty(dataJournee) &&
                  !_.isEmpty(dataJournee.derniereSieste) ? (
                    <div className="d-flex align-items-center justify-content-center content-recap">
                      <IconSieste />
                      <span className="libelle">
                        {" "}
                        {"À" +
                          " " +
                          convTime(dataJournee.derniereSieste.offsetDateTime)}
                        <strong>
                          {deltaTime(
                            dataJournee.derniereSieste.offsetDateTimeFin,
                            dataJournee.derniereSieste.offsetDateTime
                          )}
                        </strong>
                      </span>
                    </div>
                  ) : (
                    <div className="d-flex align-items-center justify-content-center content-recap">
                      <IconSieste />
                      <span className="libelle">Aucune </span>
                    </div>
                  )}
                </div>
              </div>

              {/* Timeline */}
              {!_.isEmpty(this.props.dataJournee) ? (
                <div className="col-md-8">
                  <div className="timeline-journee">
                    <div className="line"></div>
                    {kidItem &&
                    kidItem.agenda &&
                    kidItem.agenda.statutDetails.statut &&
                    (kidItem.agenda.statutDetails.statut === "PRESENT" ||
                      kidItem.agenda.statutDetails.statut === "PARTI") ? (
                      <div
                        onClick={() => this.handleModeTransmission(orderList)}
                        className="step left first"
                        data-toggle="modal"
                        data-target="#modalTransmission"
                        style={{
                          cursor: "pointer",
                          background:
                            "linear-gradient(135deg, #ffc061 0%, #ff4f68 100%)",
                          color: "#fff",
                        }}
                      >
                        <div class="d-flex justify-content-center align-items-center">
                          <span class="mr-2">
                            <strong>Faire la transmission</strong>
                          </span>
                          <IconTransmission2 />
                        </div>
                        <div class="round"></div>
                      </div>
                    ) : (
                      ""
                    )}
                    {orderList.map((eventEnfant, index) => {
                      let condition =
                        kidItem &&
                        kidItem.agenda &&
                        kidItem.agenda.statutDetails.statut &&
                        (kidItem.agenda.statutDetails.statut === "PRESENT" ||
                          kidItem.agenda.statutDetails.statut === "PARTI");

                      return condition ? (
                        <div
                          key={index}
                          style={{ cursor: "pointer" }}
                          className={Classnames({
                            first: index === 0 && !condition,
                            "step right": index % 2 === 0 && condition,
                            "step left": index % 2 !== 0 && condition,
                            last: index === orderList.length - 1,
                          })}
                          onClick={(e) =>
                            this.handleClickUpdateEvent(eventEnfant)
                          }
                        >
                          <div
                            className="d-flex justify-content-center align-items-center"
                            style={{ cursor: "pointer" }}
                          >
                            {iconEVENTSwitch(
                              eventEnfant,
                              "40px",
                              "40px",
                              "img-fluid"
                            )}
                            <span style={{ cursor: "pointer" }}>
                              <strong style={{ cursor: "pointer" }}>
                                {moment(eventEnfant.timeDebutEvent).format(
                                  "HH:mm"
                                )}
                              </strong>
                              {textEVENTSwitch(eventEnfant)}
                            </span>
                          </div>
                          <div className="round"></div>
                        </div>
                      ) : (
                        <div
                          key={index}
                          style={{ cursor: "pointer" }}
                          className={Classnames({
                            first: index === 0,
                            "step left": index % 2 === 0,
                            "step right": index % 2 !== 0,
                            last: index === orderList.length - 1,
                          })}
                          onClick={(e) =>
                            this.handleClickUpdateEvent(eventEnfant)
                          }
                        >
                          <div
                            className="d-flex justify-content-center align-items-center"
                            style={{ cursor: "pointer" }}
                          >
                            {iconEVENTSwitch(
                              eventEnfant,
                              "40px",
                              "40px",
                              "img-fluid"
                            )}
                            <span style={{ cursor: "pointer" }}>
                              <strong style={{ cursor: "pointer" }}>
                                {moment(eventEnfant.timeDebutEvent).format(
                                  "HH:mm"
                                )}
                              </strong>
                              {textEVENTSwitch(eventEnfant)}
                            </span>
                          </div>
                          <div className="round"></div>
                        </div>
                      );
                    })}
                  </div>
                </div>
              ) : (
                <div
                  style={{ margin: "auto" }}
                  className="title"
                >{`La Journée de ${!_.isEmpty(kidItem) &&
                  kidItem.prenom} n'a pas encore commencé`}</div>
              )}
            </div>
          </div>
        )}
        {this.state.modalNotifications === true &&
        this.state.NotificationList.length > 0 ? (
          <ModalNotifications
            onOpenModaleNotifications={this.onOpenModaleNotifications}
            onCloseModaleNotifications={this.onCloseModaleNotifications}
            kidItem={this.props.kidItem}
            handleDeleteNotifications={this.handleDeleteNotifications}
            dataJournee={this.props.dataJournee}
            NotificationList={this.state.NotificationList}
          />
        ) : (
          ""
        )}

        {this.state.modalTransmission ? (
          <ModalTransmission
            onCloseModaleTransmission={this.onCloseModaleTransmission}
            eventsDetails={this.state.eventsDetails}
            transmissionLoading={this.state.transmissionLoading}
          />
        ) : (
          ""
        )}
      </div>
    );
  }
}
const mapStateToProps = (state) => ({
  dataNotifications: state.ficheEnfant.Journee,
});
export default connect(mapStateToProps, {
  startUpdateEvents,
  getJournee,
  NotificationsDelete,
  getArriveEvent,
  getSanteEvent,
  getPetitCoinEvent,
  getRepasEvent,
  getSiesteEvent,
  getActiviteEvent,
  getDepartEvent,
})(Journee);
